<template>
    <v-dialog-old ref="dialog" id="rejectWithRefund">
        <form>
            <fieldset width="650">
                <legend>Причина отклонения вопроса и возврата</legend>
                <form>
                    <label>
                        <input type="radio" v-model="rejectQuestionReasonDefault" value="Отмена вопроса на основании вашего обращения">
                        <span>Отмена вопроса на основании вашего обращения</span>
                    </label>
                    <label>
                        <input type="radio" v-model="rejectQuestionReasonDefault" value="Другое">
                        <span>Другая причина</span>
                    </label>
                    <textarea v-model="rejectQuestionReason" :disabled="rejectQuestionReasonDefault !== 'Другое'"/>
                </form>
            </fieldset>

            <fieldset width="650">
                <legend>
                    <label>
                        <input type="checkbox" v-model="cancelDoctorRewards" value="Другое">
                        <span>Отменить начисление вознаграждения врачам</span>
                    </label>
                </legend>
                <form v-if="cancelDoctorRewards">
                    <label>
                        <input type="radio" v-model="rejectDoctorAwardsReasonDefault" value="Нарушение правил сервиса">
                        <span>Нарушение правил сервиса</span>
                    </label>
                    <label>
                        <input type="radio" v-model="rejectDoctorAwardsReasonDefault" value="Отсутствует ответ на вопрос">
                        <span>Отсутствует ответ на вопрос</span>
                    </label>
                    <label>
                        <input type="radio" v-model="rejectDoctorAwardsReasonDefault" value="Другое">
                        <span>Другая причина</span>
                    </label>
                    <textarea v-model="rejectDoctorAwardsReason" :disabled="rejectDoctorAwardsReasonDefault !== 'Другое'"/>
                </form>
            </fieldset>

            <footer>
                <button class="green"
                        @click="onConfirmBtn"
                        :disabled="!rejectQuestionReasonComputed || (cancelDoctorRewards && !rejectDoctorAwardsReasonComputed)">
                    Отменить публикацию
                </button>
            </footer>
        </form>
    </v-dialog-old>
</template>

<script>
export default {
    data: function () {
        return {
            rejectQuestionReasonDefault: '',
            rejectQuestionReason: '',
            rejectDoctorAwardsReasonDefault: '',
            rejectDoctorAwardsReason: '',
            cancelDoctorRewards: false,
        };
    },
    methods: {
        show () {
            this.rejectQuestionReasonDefault = '';
            this.rejectQuestionReason = '';
            this.rejectDoctorAwardsReasonDefault = '';
            this.rejectDoctorAwardsReason = '';
            this.cancelDoctorRewards = false;

            this.$refs.dialog.show();
        },
        onConfirmBtn() {
            this.$emit('rejected', this.rejectQuestionReasonComputed, this.rejectDoctorAwardsReasonComputed);
            this.$refs.dialog.hide();
        },
    },
    computed: {
        rejectQuestionReasonComputed() {
            return this.rejectQuestionReasonDefault === 'Другое' ? this.rejectQuestionReason : this.rejectQuestionReasonDefault;
        },
        rejectDoctorAwardsReasonComputed() {
            if (this.cancelDoctorRewards) {
                return this.rejectDoctorAwardsReasonDefault === 'Другое' ? this.rejectDoctorAwardsReason : this.rejectDoctorAwardsReasonDefault;
            }
            return null;
        },
    },
}
</script>

<style>
dialog#rejectWithRefund {
    width: fit-content;
}
</style>
